<template>
  <div class="vx-row" id="pages">
    <div class="vx-col w-full">
      <vx-card>
        <form v-if="!loading && loaded">
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{ $t("Version") }}</label>
              <v-select
                label="name"
                name="pageType"
                :options="pageType"
                :value="
                  pageType.filter(x => x.id == bannerDetails.pageType)[0].name
                "
                @input="pageTypeChanged"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('pageType')"
                >{{ errors.first("pageType") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="bannerDetails.pageType == 1">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{
                $t("BannerPositionInDesktopVersion")
              }}</label>
              <v-select
                label="name"
                name="bannerTypeDesktop"
                :options="bannerTypes"
                v-model="bannerDetails.bannerTypeDesktop"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerTypeDesktop')"
                >{{ errors.first("bannerTypeDesktop") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="bannerDetails.pageType == 2">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{
                $t("BannerPositionInMobileVersion")
              }}</label>
              <v-select
                label="name"
                name="bannerTypeMobile"
                :options="bannerTypeMobile"
                v-model="bannerDetails.bannerTypeMobile"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerTypeMobile')"
                >{{ errors.first("bannerTypeMobile") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="bannerDetails.name"
                :label="$t('Title')"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="bannerDetails.link"
                :label="$t('Link')"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("StartDate")
              }}</label>

              <date-picker
                v-model="bannerDetails.startClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('StartDate')"
                name="startdate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('startdate')"
                >{{ errors.first("startdate") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("EndDate")
              }}</label>

              <date-picker
                v-model="bannerDetails.expireClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('EndDate')"
                name="expiredate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('expiredate')"
                >{{ errors.first("expiredate") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="bannerDetails.priority"
                name="bannerPriority"
                v-validate="{ regex: '^([0-9]+)$' }"
                :label="$t('Priority')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerPriority')"
                >{{ errors.first("bannerPriority") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="bannerDetails.pageType == 1">
            <div class="vx-col w-full">
              <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="images"
                :maxImage="1"
                :dragText="$t('DragAndDrop')"
                :browseText="$t('UploadImage')"
                :showPrimary="false"
              ></vue-upload-multiple-image>
            </div>
          </div>
          <div class="vx-row mb-4" v-if="bannerDetails.pageType == 2">
            <div class="vx-col w-full">
              <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="images"
                :maxImage="1"
                :dragText="$t('DragAndDrop')"
                :browseText="$t('UploadImage')"
                :showPrimary="false"
              ></vue-upload-multiple-image>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-checkbox v-model="bannerDetails.isActive">{{
                $t("Active")
              }}</vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-2">
              <vs-button
                class="mb-2 submit-btn bg_l_green float-right mr-6"
                @click.prevent="submitForm"
                :disabled="disableSubmit"
                >{{ $t("Submit") }}</vs-button
              >
              <router-link
                :to="{ path: '/Banners/Index' }"
                class="vs-component vs-button back-btn"
                color="rgb(62, 201, 214)"
                type="filled"
              >
                {{ $t("BackToList") }}
              </router-link>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
.date-picker label {
  width: 110px !important;
}
#my-strictly-unique-vue-upload-multiple-image {
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.image-bottom {
  direction: ltr;
}

.image-center {
  background-color: #f8f8f8;
}

.browse-text {
  color: #017572;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
import VueUploadMultipleImage from "vue-upload-multiple-image";
const dict = {
  custom: {
    bannerTypeDesktop: {
      required: "لطفا محل قرارگیری بنر را انتخاب نمایید."
    },
    bannerTypeMobile: {
      required: "لطفا محل قرارگیری بنر را انتخاب نمایید."
    },
    title: {
      required: "لطفا عنوان را وارد نمایید."
    },
    bannerPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید."
    },
    pageType: {
      required: "لطفا نوع را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "ContentManagement_Banners_Modify",
  data() {
    return {
      pageType: [
        { name: "نسخه دسکتاپ", id: 1 },
        { name: "نسخه موبایل", id: 2 }
      ],
      bannerTypes: [
        { name: "اسلایدر اصلی، صفحه نخست", id: 1 },
        { name: "زیر اسلایدر صفحه نخست", id: 2 },

        { name: "1/2صفحه نخست", id: 7 },
        { name: "پرتال نمایندگان --- اسلایدر اصلی، صفحه نخست", id: 8 },
        { name: "پرتال نمایندگان --- پنل زیراسلایدر صفحه نخست", id: 9 },
        { name: "پرتال نمایندگان --- 1/2صفحه نخست", id: 14 }
      ],
      bannerTypeMobile: [
        { name: "اسلایدر اصلی، صفحه نخست", id: 1 },
        { name: "1/2 بالای، صفحه نخست", id: 2 },
        { name: "1/2پایین، صفحه نخست", id: 3 },
        { name: "تک بنر،بالای صفحه نخست", id: 4 },
        { name: "تک بنر،پایین صفحه نخست", id: 5 },
        { name: "پرتال نمایندگان --- اسلایدر اصلی، صفحه نخست", id: 6 },
        { name: "پرتال نمایندگان --- 1/2 بالا، صفحه نخست", id: 7 },
        { name: "پرتال نمایندگان --- 1/2پایین، صفحه نخست", id: 8 },
        { name: "پرتال نمایندگان --- تک بنر،بالای صفحه نخست", id: 9 },
        { name: "پرتال نمایندگان --- تک بنر،پایین صفحه نخست", id: 10 }
      ],
      bannerDetails: {},
      disableSubmit: false,
      loaded: false,
      images: [{ path: "" }],
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loaded = true;
    }, 2000);
  },
  computed: {
    ...mapGetters({
      banner: "banner/details",
      loading: "banner/loading"
    })
  },
  methods: {
    ...mapActions({
      fetchSingle: "banner/fetchSingle",
      updateBanner: "banner/update"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.bannerDetails = Object.assign({}, this.banner);

        if (this.bannerDetails.uri) {
          this.images[0].path =
            this.URLS_CONSTANTS.assets + "Banner/" + this.bannerDetails.uri;
        }
        if (this.bannerDetails.mobileUri) {
          this.images[0].path =
            this.URLS_CONSTANTS.assets +
            "BannerMobile/" +
            this.bannerDetails.mobileUri;
        }
      });
    },
    pageTypeChanged(id) {
      this.bannerDetails.pageType = id;
      this.images = [];
      if (this.bannerDetails.pageType == 1) {
        this.bannerDetails.mobileImage = "";
      }
      if (this.bannerDetails.pageType == 2) {
        this.bannerDetails.image = "";
      }
    },
    uploadImageSuccess(formData, index, fileList) {
      if (this.bannerDetails.pageType == 1) {
        this.bannerDetails.image = fileList[index].path;
        this.bannerDetails.mobileImage = "";
      }
      if (this.bannerDetails.pageType == 2) {
        this.bannerDetails.mobileImage = fileList[index].path;
        this.bannerDetails.image = "";
      }
    },
    beforeRemove(index, done) {
      done();
      if (this.bannerDetails.pageType == 1) {
        this.bannerDetails.image = "";
      }
      if (this.bannerDetails.pageType == 2) {
        this.bannerDetails.mobileImage = "";
      }
    },
    editImage(formData, index, fileList) {
      setTimeout(() => {
        if (this.bannerDetails.pageType == 1) {
          this.bannerDetails.image = fileList[index].path;
          this.images[0].path = fileList[index].path;
          this.bannerDetails.mobileImage = "";
        }
        if (this.bannerDetails.pageType == 2) {
          this.bannerDetails.mobileImage = fileList[index].path;
          this.images[0].path = fileList[index].path;
          this.bannerDetails.image = "";
        }
      }, 500);
    },
    submitForm() {
      this.disableSubmit = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateBanner(this.bannerDetails)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000
              });
            })
            .then(() => this.$router.push("/Banners/Index"));
        }
      });
    }
  },
  components: {
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
    VueUploadMultipleImage
  }
};
</script>
